import type { PublishedEntryResponseDto, SearchResultProps } from './schema.ts';

export const extractArgsSearchResult = (source: PublishedEntryResponseDto) => {
  const media = source.media
    ? {
        image: {
          url: source.media?.image?.url || undefined,
          alt: source.media?.image?.alt || undefined,
          height: source.media?.image?.height || undefined,
          width: source.media?.image?.width || undefined,
          focus: source.media?.image?.focus || undefined,
          ratio: source.media?.image?.ratio || undefined,
        },
      }
    : undefined;
  const fund = source.fund
    ? {
        id: source.fund.id,
        tcmId: source.fund.tcmId,
        fundTitle: source.fund.fundTitle,
        fundCodeOneTime: source.fund.fundCodeOneTime,
        fundCodeCommitment: source.fund.fundCodeCommitment,
        catalogAmount: source.fund.catalogAmount,
      }
    : undefined;
  return {
    title: source.pageTitle || undefined,
    summary: source.summary || undefined,
    searchKeywords: source.searchKeywords || undefined,
    publishDate: source.datePublished || undefined,
    path: source.path || undefined,
    media,
    fund,
    contributors: source.contributors || undefined,
    taxonomyArticleType: source.taxonomy?.articleType || undefined,
    taxonomyArticleTheme: source.taxonomy?.articleThemes || undefined,
    taxonomyFundCategory: source.taxonomy?.fundCategory || undefined,
    taxonomyFundPromotion: source.taxonomy?.fundPromotion || undefined,
    taxonomyTopic: source.taxonomy?.articleTopics || undefined,
    taxonomyProgramCountry: source.taxonomy?.programCountry || undefined,
    taxonomyProgramRegion: source.taxonomy?.programRegion || undefined,
    taxonomyCmsOrganization: source.taxonomy?.cmsOrganization || undefined,
  } as SearchResultProps;
};
